export function any(previousValue: boolean, currentValue: boolean) {
  return previousValue || currentValue;
}

export function all(previousValue: boolean, currentValue: boolean) {
  return previousValue && currentValue;
}
